export default __webpack_public_path__ + "static/media/CLEANCODE.3b0a20a7.png";